<template>
  <div class="user-center__order-container user-center__common-child-container">
    <SubPageHeader>
      <template #title>
        <router-link
          tag="div"
          :to="nav.url"
          active-class="active"
          class="title__front-item"
          v-for="(nav, index) in breadcrumbs"
          :key="index"
          >{{ nav.name }}</router-link
        >
      </template>
    </SubPageHeader>
    <div class="order__main-body">
      <div class="order__list-container">
        <router-view :key="$route.fullpath"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../_pageHeader.vue';

export default {
  props: {
    type: {
      type: String,
      default: undefined,
    },
  },
  components: {
    SubPageHeader,
  },
  data() {
    return {
      breadcrumbs: [
        {
          name: '待发货',
          url: '/my/orders/undelivered',
        },
        {
          name: '已发货',
          url: '/my/orders/delivered',
        },
      ],
      pageSize: 15,
    };
  },
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  created() {},
  methods: {
    init() {
    },
    getOrders() {
      return this.$http.post('html/user/myOrder', {
        page: this.page,
        page_size: this.page_size,
      });
    },
  },
};
</script>

<style></style>
